import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { platformTours } from '@constants/tours';
import { TourE } from '@enums/tour.enum';
import { UserPreferencesService } from '@modules/users/user.preferences.service';
import { TranslateService } from '@ngx-translate/core';
import introJs from 'intro.js';

@Injectable({
  providedIn: 'root',
})
export class TourHelperService {
  constructor(
    private userPreferencesService: UserPreferencesService,
    private translateService: TranslateService,
    private router: Router
  ) {}

  public async startTour(tourToShow: TourE, force?: boolean, onComplete?: () => void | Promise<void>) {
    const selectedTour = platformTours.find((tour) => tour.tour === tourToShow);
    if (selectedTour) {
      const userPreferences = await this.userPreferencesService.getPreferences();
      if (force || !userPreferences?.viewedTours || !userPreferences.viewedTours.includes(tourToShow)) {
        const runFunction = async () => {
          selectedTour.config.steps = selectedTour.config.steps?.filter((step) => {
            if (typeof step.element === 'string') {
              return document.querySelector(step.element) !== null;
            }
            return true;
          });
          const introJS = introJs();

          //Tenta traduzir as mensagens
          selectedTour.config.steps?.forEach((step) => {
            step.intro = this.translateService.instant(step.intro || 'NOT_TRANSLATED_YET');
            step.title = this.translateService.instant(step.title || 'NOT_TRANSLATED_YET');
          });

          introJS.setOptions({
            ...selectedTour.config,
            exitOnOverlayClick: false,
            buttonClass: 'omni-tour-button',
            tooltipClass: 'omni-tour-tooltip',
            highlightClass: 'omni-tour-highlight',
            nextLabel: this.translateService.instant('NEXT'),
            prevLabel: this.translateService.instant('PREVIOUS'),
            doneLabel: this.translateService.instant('DONE'),
          });

          if (onComplete) {
            introJS.onexit(onComplete);
          }

          introJS.start();

          if (!force) {
            await this.userPreferencesService.patchPreferences({
              viewedTours: [...(userPreferences?.viewedTours || []), tourToShow],
            });
          }
        };

        if (selectedTour.navigate && selectedTour.forRoute && selectedTour.forRoute !== this.router.url) {
          await this.router.navigate([selectedTour.forRoute]);
          setTimeout(runFunction, 500);
        } else {
          runFunction();
        }
      }
    }
  }

  public async startAllTours(tours: TourE[], force = false) {
    let toursToRun = tours;
    const startNextTour = () => {
      const tour = toursToRun.shift();
      if (tour) {
        this.startTour(tour, force, () => {
          startNextTour();
        });
      }
    };

    startNextTour();
  }

  public async startTourForCurrentRoute(force = false) {
    const currentRoute = this.router.url;
    const selectedTour = platformTours.find((tour) => tour.forRoute === currentRoute);
    if (selectedTour) {
      await this.startTour(selectedTour.tour, force);
    }
  }

  public doesCurrentRouteHasTour() {
    const currentRoute = this.router.url;
    return platformTours.find((tour) => tour.forRoute === currentRoute) !== undefined;
  }
}
